module.exports = __webpack_public_path__ + "img/product-type-item-bg-active.6d0d72e3.png";